<template>
    <vs-popup id="create-marketing-lead-popup" class="manage-indirect-channel" :title="'CHANNEL PARTNER DETAILS'"
        @close="open = false" :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow style="line-height: 2;" class="font-bold text-primary text-xl">

            <div class="vx-row">
                <div class="vx-col w-2/3">
                    Partner Code: {{ channel_partner_data.code }} <br>
                    Channel Partner Name: {{ channel_partner_data.company_name }} <br>
                    <span class="text-warning" v-if="create_type === 'product'">Customer: {{ selected_channel.customer_name
                    }}</span>

                </div>
                <div class="vx-col w-1/3" v-if="!is_on_create_mode">
                    Revenue (GBP): {{ summary.revenue }} <br>
                    Customers: {{ summary.customers }} <br>
                    Commission Earned (GBP): {{ summary.commission_earned }} <br>
                    Average Revenue (GBP): {{ summary.average_revenue }} <br>
                </div>
            </div>
        </vx-card>
        <vx-card no-shadow v-if="!is_on_create_mode">
            <template slot="actions">
                <div class="flex">
                    <vx-tooltip text="refresh" v-if="indirect_channels.length > 0">
                        <vs-button icon-pack="feather" icon="icon-rotate-cw" @click.stop="fetchIncotermDetails"
                            class="mr-4 mb-4" color="warning" type="border">
                        </vs-button>
                    </vx-tooltip>
                    <vs-button @click="onClickCreate('customer')" class="mr-4 mb-4" color="primary" type="filled">
                        + Add customer
                    </vs-button>
                </div>
            </template>
            <vs-table :data="indirect_channels" v-if="indirect_channels.length > 0">

                <template slot="thead">
                    <vs-th width="25%">CREATED DATE/TIME</vs-th>
                    <vs-th width="25%">CUSTOMER INTRODUCED</vs-th>
                    <vs-th width="25%">CUSTOMER ID</vs-th>
                    <vs-th width="25%"></vs-th>
                </template>

                <template slot-scope="{data}">
                    <vs-tr :key="indextr" v-for="(tr, indextr) in data">

                        <vs-td :data="data[indextr].created_at">
                            {{ __dateTimeFormatter(data[indextr].created_at) }}
                        </vs-td>

                        <vs-td :data="data[indextr].customer_name">
                            {{ data[indextr].customer_name }}
                        </vs-td>

                        <vs-td :data="data[indextr].customer_account_number">
                            {{ data[indextr].customer_account_number }}
                        </vs-td>

                        <vs-td>
                            <div class="vx-row">
                                <vx-tooltip class="mr-2" text="view agreements" position="top">
                                    <vs-button size="small" color="primary" type="border" icon-pack="feather"
                                        icon="icon-eye"></vs-button>
                                </vx-tooltip>
                            </div>
                        </vs-td>

                        <template class="expand-user" slot="expand">
                            <div class="con-expand-users w-5/6">
                                <vs-button class="mb-4" @click.stop="onClickCreate('product', data[indextr])" size="">
                                    + Add product
                                </vs-button>
                                <vs-table :data="data[indextr].product_commissions">

                                    <template slot="thead">
                                        <vs-th width="10%">PARTNER COMMISSION AGREEMENT CODE</vs-th>
                                        <vs-th width="10%">DATE INTRODUCED</vs-th>
                                        <vs-th width="15%">DATE AGREEMENT STARTED</vs-th>
                                        <vs-th width="15%">AGREEMENT END DATE</vs-th>
                                        <vs-th width="20%">PRODUCT</vs-th>
                                        <vs-th width="10%">COMMISSION (%)</vs-th>
                                        <vs-th width="10%">AGREEMENT STATUS</vs-th>
                                        <vs-th width="10%">ACTION</vs-th>
                                    </template>

                                    <template slot-scope="{data}">
                                        <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">

                                            <vs-td :data="tr_item.code">
                                                {{ tr_item.code }}
                                            </vs-td>
                                            <vs-td :data="tr_item.date_introduced">
                                                {{ tr_item.date_introduced }}
                                            </vs-td>
                                            <vs-td :data="tr_item.start_date">
                                                {{ tr_item.start_date }}
                                            </vs-td>
                                            <vs-td :data="tr_item.end_date">
                                                {{ tr_item.end_date }}
                                            </vs-td>
                                            <vs-td>
                                                {{ tr_item.formulation_code }} <br> {{ data[index_item].formulation_name }}
                                            </vs-td>
                                            <vs-td :data="tr_item.percent">
                                                {{ tr_item.percent }}
                                            </vs-td>
                                            <vs-td :data="tr_item.status">
                                                {{ tr_item.status }}
                                            </vs-td>
                                            <vs-td>
                                                <div class="vx-row">
                                                    <vx-tooltip class="mr-2" text="Update Agreement" position="top">
                                                        <vs-button @click.stop="onClickUpdateProduct(tr_item)" size="small"
                                                            color="warning" type="border" icon-pack="feather"
                                                            icon="icon-edit"></vs-button>
                                                    </vx-tooltip>
                                                    <vx-tooltip v-if="tr_item.status !== 'Suspended'" class="mr-2"
                                                        text="Suspend the agreement" position="top">
                                                        <vs-button @click.stop="onClickSuspendProduct(tr_item.id)"
                                                            size="small" color="danger" type="border" icon-pack="feather"
                                                            icon="icon-x-square"></vs-button>
                                                    </vx-tooltip>
                                                </div>
                                            </vs-td>

                                        </vs-tr>
                                    </template>
                                </vs-table>

                            </div>
                        </template>
                    </vs-tr>
                </template>
            </vs-table>
        </vx-card>
        <!-- create mode enable -->
        <vx-card no-shadow v-if="is_on_create_mode">

            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form autocomplete="off" @submit.prevent="handleSubmit(onClickSubmit)">
                    <div class="vx-row mb-8 mt-1" v-if="!!error_obj">
                        <div class="vx-col w-full px-8">
                            <vs-alert class="mt-1 font-bold w-full" color=danger
                                title="This product is already linked to another customer" icon-pack="feather"
                                icon="icon-info">
                                Product: {{ error_obj[0].formulation_code }} |
                                Agreement Code: {{ error_obj[0].code }} | Customer Name: {{
                                    error_obj[0].customer_name }} | Agreement Start Date: {{
        error_obj[0].start_date }} | Agreement End Date: {{
        error_obj[0].end_date }}
                            </vs-alert>
                        </div>
                    </div>
                    <div class="mb-3 vx-row">
                        <div class="vx-col md:w-1/2 w-full md:mb-0">
                            <ValidationProvider vid="products" name="products" rules="required" v-slot="{ errors }">
                                <small class="label">Product</small>
                                <v-select @input="onInputProductRow" :disabled="!!selected_product" :clearable="false"
                                    :closeOnSelect="true" name="products" placeholder="" label="name"
                                    v-model="form.formulation_id" :reduce="option => option.id" :options="product_list"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template slot="option" slot-scope="option">
                                        <span>{{ option.formulation_code }} - {{ option.name }}</span>
                                    </template>
                                    <template slot="selected-option" slot-scope="option">
                                        <span>{{ option.formulation_code }} - {{ option.name }}</span>
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="commission_percent" name="commission_percent" rules="required"
                                v-slot="{ errors }">
                                <small class="label">Commission Percentage (%)</small>
                                <vs-input :disabled="!!selected_product" v-model="form.percent" name="commission_percent"
                                    class="w-full" label="" :danger="!!errors[0]" :danger-text="errors[0]"
                                    val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="start_date" name="start_date" rules="required" v-slot="{ errors }">
                                <small class="label">Agreement Start Date</small>
                                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full hidden"
                                    v-model="form.start_date" placeholder="Choose Date" />
                                <flat-pickr @input="onInputProductRow" :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                                    v-model="form.start_date" placeholder="Choose Date" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="end_date" name="end_date" rules="required" v-slot="{ errors }">
                                <small class="label">Agreement End Date</small>
                                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full hidden" v-model="form.end_date"
                                    placeholder="Choose Date" />
                                <flat-pickr @input="onInputProductRow" :config="{ dateFormat: 'd/m/Y' }" class="w-full"
                                    v-model="form.end_date" placeholder="Choose Date" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>
                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="date_introduced" name="date_introduced" rules="required"
                                v-slot="{ errors }">
                                <small class="label">Date Introduced</small>
                                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full hidden"
                                    v-model="form.date_introduced" placeholder="Choose Date" />
                                <flat-pickr :config="{ dateFormat: 'd/m/Y' }" class="w-full" v-model="form.date_introduced"
                                    placeholder="Choose Date" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>


                    <!-- Save & Reset Button -->
                    <div class="flex flex-wrap items-center justify-end mt-8">
                        <vs-button button="submit" class="mt-2 ml-auto">Save
                            Changes</vs-button>
                        <vs-button @click.stop="onClickBackToList" color=warning class="mt-2 ml-4" type="border">Back to
                            list</vs-button>
                    </div>

                </form>
            </ValidationObserver>
        </vx-card>
    </vs-popup>
</template>
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'
const CrmRepository = RepositoryFactory.get('crm');
import CustomerDropdown from "@/components/drop-down-filters/CustomerDropdown";
const DropDownRepository = RepositoryFactory.get('drop_down')
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

function initialState() {
    return {
        open: false,
        form: {
            formulation_id: null,
            date_introduced: null,
            start_date: null,
            end_date: null,
            percent: null
        },
        channel_partner_data: {
            code: '',
            company_name: ''
        },
        id: null,
        indirect_channels: [],
        is_on_create_mode: false,
        create_type: '',
        selected_channel: null,
        customer_list: [],
        product_list: [],
        error_obj: null,
        selected_product: null,
        summary: {
            revenue: 0,
            customers: 0,
            commission_earned: 0,
            average_revenue: 0
        }
    }
}

export default {
    name: 'ManageIndirectChannelPartnerPopUp',
    data() {
        return initialState()
    },
    components: {
        flatPickr,
        'v-select': vSelect,
        CustomerDropdown
    },
    mixins: [SuccessMessage, ErrorMessages],
    methods: {
        async openPopup(id) {
            try {
                await Object.assign(this.$data, initialState());
                this.open = true
                this.id = id
                await this.fetchIncotermDetails()
                await this.fetchSummary()
            } catch (e) {

            }
        },
        async fetchIncotermDetails() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                this.indirect_channels = []
                const { data } = (await CrmRepository.getIndirectChannelDetails(this.id)).data
                this.indirect_channels = data.customers
                this.channel_partner_data = data
            } catch (e) {
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickCreate(type, data) {
            this.create_type = type
            if (this.create_type === 'customer') {
                this.open = false
                await this.$emit('createCustomerForChannel', this.id)
            }
            if (this.create_type === 'product') {
                await this.fetchProducts()
                this.selected_channel = data
                this.is_on_create_mode = true
            }
        },
        onClickUpdateProduct(data) {
            this.selected_product = data
            this.form.date_introduced = data.date_introduced
            this.form.start_date = data.start_date
            this.form.end_date = data.end_date
            this.form.percent = data.percent
            this.form.product_id = data.formulation_id
            this.form.formulation_id = data.formulation_code
            this.is_on_create_mode = true
        },
        async fetchCustomers() {
            try {
                const { data } = (await DropDownRepository.getCustomersList()).data
                const existing_customer_ids = this.indirect_channels.map((x) => x.customer_id)
                this.customer_list = data.filter((x) => !existing_customer_ids.includes(x.id))
            } catch (error) {

            }
        },
        async fetchProducts() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const { data } = (await DropDownRepository.getFormulationList('filter[status]=Production')).data
                this.product_list = data
            } catch (error) {

            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickSubmit() {
            try {
                this.form.percent = Number(this.form.percent).toFixed(2)
                if (this.create_type === 'product') {
                    await CrmRepository.createIndirectChannelProduct(this.selected_channel.id, this.form)
                    this.showSuccessMessage('Product added successfully!')
                } else if (!!this.selected_product) {
                    await CrmRepository.updateProductAgreement(this.selected_product.id, {
                        date_introduced: this.form.date_introduced,
                        start_date: this.form.start_date,
                        end_date: this.form.end_date
                    })
                    this.showSuccessMessage('Product updated successfully!')
                }
                this.is_on_create_mode = false
                this.resetToInitialState()
                await this.fetchIncotermDetails()
            } catch (error) {
                this.convertAndNotifyError(error)

            }
        },
        async onClickSuspendProduct(id) {
            try {
                await CrmRepository.indirectChannelProductStatusChange(id, { status: 'Suspended' })
                await this.fetchIncotermDetails()
            } catch (error) {
                this.convertAndNotifyError(error)
            }
        },
        async onClickBackToList() {
            this.is_on_create_mode = false
            this.resetToInitialState()
        },
        resetToInitialState() {
            this.selected_product = null
            this.selected_channel = null
            this.create_type = ''
            this.form = {
                formulation_id: null,
                date_introduced: null,
                start_date: null,
                end_date: null,
                percent: null
            }
            this.error_obj = null
        },
        async fetchSummary() {
            try {
                const { data } = (await CrmRepository.getIndirectChannelSummary(this.id)).data
                this.summary = data
            } catch (error) {

            }
        },
        async onInputProductRow() {
            if (this.form.formulation_id && this.form.start_date && this.form.end_date) {
                const params = `from=${this.form.start_date}&to=${this.form.end_date}&formulation-id=${!this.selected_product ? this.form.formulation_id : this.form.product_id}`
                const { data } = await CrmRepository.checkProductAvailability(params)
                this.error_obj = data.data
            }
        }
    }
}
</script>
<style scoped>
.manage-indirect-channel>>>.vs-popup {
    min-height: 50% !important;
    min-width: 65% !important;
}
</style>